import axios from "axios";
import React, { useEffect, useState } from "react";
import { getHeader } from "../../../service/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Card, CardActionArea, CardContent, Typography, Box, Grid } from "@mui/material";
import { ArrowBack, AssignmentOutlined } from "@mui/icons-material";
import themeNutriFast from "../../../styles/NutriFastColors";
import BreadcrumbNav from "../../../components/BreadcrumbNav";
import PageTransition from "../../../components/PageTransition";
import { TouchFeedback } from "../../../components/RippleEffect";
import { BounceClick } from "../../../components/MicroInteractions";

const ShowUser = () => {
  const headers = getHeader();
  const [list, setList] = useState([]);
  let navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_ADMIN + "/questionnaire/user/" + state.id, {
        headers,
      })
      .then(({ data }) => {
        setList(data);
      });
  }, []);

  const handleChangePage = (page,quest) => {
    if (page) navigate(page, { state: {quest: quest, user_id : state.id, userName: state.name} });
  };

  const breadcrumbItems = [
    { label: 'Accueil', path: '/' },
    { label: 'Gestion des utilisateurs', path: '/admin/gestion_user' },
    { label: `Questionnaires de ${state?.name || 'l\'utilisateur'}`, path: null }
  ];

  return (
    <PageTransition>
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <BreadcrumbNav items={breadcrumbItems} />

        <BounceClick>
          <TouchFeedback>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => navigate('/admin/gestion_user')}
              sx={{
                color: themeNutriFast.palette.primary.dark,
                borderColor: themeNutriFast.palette.primary.dark,
                mb: 3,
                '&:hover': {
                  backgroundColor: 'rgba(2, 62, 138, 0.04)',
                  borderColor: themeNutriFast.palette.primary.main
                }
              }}
            >
              Retour
            </Button>
          </TouchFeedback>
        </BounceClick>

        <Typography
          variant="h5"
          sx={{
            mb: 3,
            color: themeNutriFast.palette.primary.dark,
            fontWeight: 600
          }}
        >
          Questionnaires de {state?.name || 'l\'utilisateur'}
        </Typography>

        {list && list.length > 0 ? (
          <Grid container spacing={2}>
            {list.map((quest, index) => (
              <Grid item xs={12} key={`quest-${quest.id}`}>
                <TouchFeedback scaleDown={0.98} scaleUp={1.02}>
                  <Card
                    elevation={2}
                    sx={{
                      height: '100%',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      '&:hover': {
                        elevation: 6,
                        transform: 'translateY(-4px)',
                        boxShadow: '0 8px 24px rgba(2, 62, 138, 0.15)',
                        '& .quest-icon': {
                          color: themeNutriFast.palette.primary.main,
                          transform: 'scale(1.1)'
                        }
                      }
                    }}
                  >
                    <CardActionArea
                      onClick={() => handleChangePage("/admin/q/" + quest.name, quest)}
                      sx={{ height: '100%', p: 2 }}
                    >
                      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <AssignmentOutlined
                          className="quest-icon"
                          sx={{
                            fontSize: 40,
                            color: themeNutriFast.palette.primary.dark,
                            transition: 'all 0.3s ease'
                          }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 500,
                            color: themeNutriFast.palette.primary.dark,
                            flex: 1
                          }}
                        >
                          {quest.name}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </TouchFeedback>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            sx={{
              textAlign: 'center',
              py: 8,
              color: '#666'
            }}
          >
            <AssignmentOutlined sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
            <Typography variant="h6" color="textSecondary">
              Aucun questionnaire disponible
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Associez des questionnaires à cet utilisateur depuis la liste des utilisateurs
            </Typography>
          </Box>
        )}
      </Box>
    </PageTransition>
  );
};

export default ShowUser;
